import { Navigate } from 'react-router-dom';
import { useAuth }  from './AuthContext';
import EmojiLoader  from './EmojiLoader';

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <EmojiLoader />;

  // Apenas garante que está logado. Sem regras de onboarding aqui!
  if (!user) return <Navigate to="/login" replace />;

  return children;
}